export default __webpack_public_path__ + "static/media/Icon ionic-md-lock.2a3fec13.svg";